import type * as Types from '@xingternal/pages-graphql-types';

import * as Operations from './CoverImageQuery.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CoverImageFragment = (
  { __typename?: 'ScaledImage' }
  & Pick<Types.ScaledImage, 'reference' | 'url'>
);

export type EntityPageCoverImageQueryVariables = Types.Exact<{
  id: Types.Scalars['SlugOrID']['input'];
  dimensions?: Types.InputMaybe<Array<Types.ScaledImageDimension> | Types.ScaledImageDimension>;
}>;


export type EntityPageCoverImageQuery = (
  { __typename?: 'Query' }
  & { entityPageEX?: Types.Maybe<(
    { __typename?: 'EntityPage' }
    & Pick<Types.EntityPage, 'id' | 'globalId'>
    & { coverImage?: Types.Maybe<Array<(
      { __typename?: 'ScaledImage' }
      & CoverImageFragment
    )>> }
  ) | (
    { __typename?: 'EntityPageError' }
    & Pick<Types.EntityPageError, 'errorType' | 'errorCode'>
  ) | { __typename?: 'EntityPageMoved' }> }
);



/**
 * __useEntityPageCoverImageQuery__
 *
 * To run a query within a React component, call `useEntityPageCoverImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityPageCoverImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityPageCoverImageQuery({
 *   variables: {
 *      id: // value for 'id'
 *      dimensions: // value for 'dimensions'
 *   },
 * });
 */
export function useEntityPageCoverImageQuery(baseOptions: Apollo.QueryHookOptions<EntityPageCoverImageQuery, EntityPageCoverImageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityPageCoverImageQuery, EntityPageCoverImageQueryVariables>(Operations.EntityPageCoverImage, options);
      }
export function useEntityPageCoverImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityPageCoverImageQuery, EntityPageCoverImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityPageCoverImageQuery, EntityPageCoverImageQueryVariables>(Operations.EntityPageCoverImage, options);
        }
export type EntityPageCoverImageQueryHookResult = ReturnType<typeof useEntityPageCoverImageQuery>;
export type EntityPageCoverImageLazyQueryHookResult = ReturnType<typeof useEntityPageCoverImageLazyQuery>;
export type EntityPageCoverImageQueryResult = Apollo.QueryResult<EntityPageCoverImageQuery, EntityPageCoverImageQueryVariables>;